(function() {
  function getStockForVariant(variantId) {
    let stock = Infinity;
    document.querySelectorAll('script.variant-stock-data').forEach(s => {
      try {
        const map = JSON.parse(s.textContent);
        if (map[variantId] != null) {
          stock = Math.min(stock, map[variantId]);
        }
      } catch (e) {}
    });
    return stock;
  }

  async function getCommittedQuantity(variantId) {
    const cards = JSON.parse(localStorage.getItem('cards')) || [];
    const inBucket = cards.filter(c => Number(c.id) === Number(variantId)).length;

    let inCart = 0;
    try {
      const cart = await fetch(`/cart.js?_=${Date.now()}`).then(r => r.json());
      cart.items.forEach(item => {
        if (Number(item.variant_id) === Number(variantId)) {
          inCart += item.quantity;
        }
     const bundleProperty = (item.properties && item.properties._bundle_products)
                    || (item.properties && item.properties._contents);
if (bundleProperty) {
  const ids = String(bundleProperty).split(',').map(s => Number(s.trim()));
  const matches = ids.filter(id => id === Number(variantId)).length;
  inCart += matches * item.quantity;
}
      });
    } catch (e) {
      console.warn('[InventoryCheck] /cart.js fetch failed:', e);
    }

    return { inBucket, inCart, total: inBucket + inCart };
  }

  async function canAddToInventory(variantId, requestedQty = 1) {
    const stock = getStockForVariant(variantId);
    if (stock === Infinity) {
      return { ok: true, stock: Infinity, committed: 0, remaining: Infinity };
    }
    const { inBucket, inCart, total } = await getCommittedQuantity(variantId);
    const remaining = stock - total;
    return {
      ok: requestedQty <= remaining,
      stock,
      inBucket,
      inCart,
      committed: total,
      remaining
    };
  }

  window.InventoryCheck = {
    getStockForVariant,
    getCommittedQuantity,
    canAddToInventory
  };

  console.log('[InventoryCheck] loaded');
})();